import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import AboutUsLanding from "../views/AboutUsLanding";
import Values from "../ones/Values";
import WhyWork from "../ones/WhyWork";
import Footer from "../ones/Footer";
import { Helmet } from "react-helmet-async";

export default function AboutUs(props) {
  const appContext = useContext(AppContext);

  const [view, setView] = useState(null);

  async function init() {
    //run initializations here
  }

  function getView() {
    if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <AboutUsLanding />;
    } else if (
      appContext.navSubItem === "values" &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <Values />;
    } else if (
      appContext.navSubItem === "work-with-us" &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <WhyWork />;
    }

    return null;
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const _view = getView();
    if (_view) {
      setView(_view);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  //return desired view
  return (
    <>
      <Helmet>
        <title>About Us | Group V Limited</title>
        <meta
          name="description"
          content="Learn more about Groupv and our commitment to providing exceptional services in Tanzania."
        />
        <meta property="og:title" content="About Us | Groupv" />
        <meta
          property="og:description"
          content="Discover the story behind Groupv and what makes us different in the industry."
        />
        <meta property="og:url" content="https://groupv.co.tz/#/about_us" />
      </Helmet>
      {view}
    </>
  );
}
